<!-- <div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="contactWizOpen" style="width: 80%; height: auto; padding: 0;"> -->
<lib-create-contact-wizard #contactWizard
    [darkMode]="darkMode"
    [glassMode]="glassMode"
    [contactTypes]="contactTypes"
    (wizardCompletedEmitter)="wizardCompletedEmitter.emit($event)"
    (wizardSoftCompletionEmitter)="wizardSoftCompletionEmitter.emit($event)"
    (wizardCancelledEmitter)="wizardCancelledEmitter.emit(null)">
    <ng-content></ng-content>
</lib-create-contact-wizard>

<!-- </div> -->